import { render, staticRenderFns } from "./SelectCabins.vue?vue&type=template&id=1956b164&"
import script from "./SelectCabins.vue?vue&type=script&setup=true&lang=js&"
export * from "./SelectCabins.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SelectCabins.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports